import React from 'react';
import { ExternalLink } from 'lucide-react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../ui/dialog';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const ContratoUploadModal = ({
  open,
  onClose,
  reserva,
  archivo,
  setArchivo,
  subiendo,
  onSubir,
  formatDate
}) => {
  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="max-w-lg">
        <DialogHeader>
          <DialogTitle className="text-2xl font-bold text-[#0E3A53]">
            {reserva?.contrato_firmado_url ? 'Ver/Actualizar Contrato Firmado' : 'Adjuntar Contrato Firmado'}
          </DialogTitle>
        </DialogHeader>
        <div className="space-y-4">
          {reserva?.contrato_firmado_url && (
            <div className="p-4 bg-green-50 border border-green-200 rounded-lg">
              <p className="text-sm text-green-800 mb-2">✓ Contrato firmado ya adjuntado</p>
              <a
                href={`${BACKEND_URL}${reserva.contrato_firmado_url}`}
                target="_blank"
                rel="noopener noreferrer"
                className="text-blue-600 hover:text-blue-800 underline text-sm flex items-center gap-2"
              >
                <ExternalLink className="w-4 h-4" />
                Ver contrato actual
              </a>
            </div>
          )}
          
          <div>
            <Label htmlFor="contrato-file" className="text-[#0E3A53]">
              {reserva?.contrato_firmado_url ? 'Subir nuevo contrato (reemplazará el actual)' : 'Seleccionar archivo (PDF o imagen)'}
            </Label>
            <p className="text-sm text-gray-500 mb-2">Sube el contrato físico firmado escaneado</p>
            <Input
              id="contrato-file"
              type="file"
              accept=".pdf,.jpg,.jpeg,.png"
              onChange={(e) => setArchivo(e.target.files[0])}
              className="cursor-pointer"
            />
            {archivo && (
              <p className="text-sm text-green-600 mt-2">
                ✓ Archivo seleccionado: {archivo.name}
              </p>
            )}
          </div>

          <div className="border-t pt-4">
            <p className="text-sm text-gray-600 mb-2">
              <strong>Huésped:</strong> {reserva?.huesped_nombre}
            </p>
            <p className="text-sm text-gray-600">
              <strong>Fechas:</strong> {formatDate(reserva?.fecha_check_in)} - {formatDate(reserva?.fecha_check_out)}
            </p>
          </div>

          <div className="flex gap-2 justify-end pt-4">
            <Button 
              variant="outline" 
              onClick={onClose}
              disabled={subiendo}
            >
              Cancelar
            </Button>
            <Button 
              onClick={onSubir}
              disabled={!archivo || subiendo}
              className="bg-gradient-to-r from-[#1AA1D8] to-[#0E3A53]"
            >
              {subiendo ? 'Subiendo...' : 'Guardar Contrato'}
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default ContratoUploadModal;
